import service from "@/utils/request";

/**
 * 获取司机列表
 * @returns 
 */
export function getPaymentList() {
  return service({
    url: '/fleet/pending_payment/driver/list',
    method: "get",
    headers: {
      "portal-token": true
    }
  })
}

/**
 * 获取司机payment详情
 * @param {Number} id 
 * @returns 
 */
export function getPaymentDetail(id) {
  return service({
    url: `/fleet/pending_payment/list/${id}`,
    method: "get",
    headers: {
      "portal-token": true
    }
  })
}


/**
 * 获取司机settlement detail详情
 * @param {Number} id 
 * @returns 
 */
export function getSettlementDetail(id) {
  return service({
    url: `/fleet/load/V3/detail?loadId=${id}`,
    method: "get",
    headers: {
      "portal-token": true
    }
  })
}

/**
 * 新增司机expense详情
 * @param {*} data 
 * @returns 
 */
 export function addExpense(data) {
  return service({
    url: "/fleet/pending_payment/add",
    method: "post",
    headers: {
      "portal-token": true
    },
    data
  })
}

/**
 * 编辑司机expense详情
 * @param {*} data 
 * @returns 
 */
 export function editExpense(data) {
  return service({
    url: "/fleet/pending_payment/update",
    method: "put",
    headers: {
      "portal-token": true
    },
    data
  })
}

/**
 * 删除expense
 * @param {Number} id 
 * @returns 
 */
export function delExpense(id) {
  return service({
    url: `/fleet/pending_payment/delete/${id}`,
    method: "delete",
    headers: {
      "portal-token": true
    }
  })
}

/**
 * 新增司机payment详情
 * @param {*} data 
 * @returns 
 */
 export function addPayment(data) {
  return service({
    url: "/fleet/schedule_pending_payment/add",
    method: "post",
    headers: {
      "portal-token": true
    },
    data
  })
}

/**
 * 编辑司机payment详情
 * @param {*} data 
 * @returns 
 */
 export function editPayment(data) {
  return service({
    url: "/fleet/schedule_pending_payment/update",
    method: "put",
    headers: {
      "portal-token": true
    },
    data
  })
}

/**
 * 删除payment
 * @param {Number} id 
 * @returns 
 */
 export function delPayment(id) {
  return service({
    url: `/fleet/schedule_pending_payment/delete/${id}`,
    method: "delete",
    headers: {
      "portal-token": true
    }
  })
}

/**
 * 创建payment
 * @param {*} data 
 * @returns 
 */
export function createReport(data) {
  return service({
    url: "/fleet/payment_report/create_report",
    method: "post",
    headers: {
      "portal-token": true
    },
    data
  })
}

/**
 * 获取Report List
 * @param {*} data 
 * @returns 
 */
export function getReportPageList(data) {
  return service({
    url: "/fleet/payment_report/page/list",
    method: "post",
    headers: {
      "portal-token": true
    },
    data
  })
}

/**
 * 发送邮件
 * @param {*} data 
 */
export function sendReportToDriver(data) {
  return service({
    url: "/fleet/payment_report/send_email",
    method: "post",
    headers: {
      "portal-token": true
    },
    data
  })
}

/**
 * 获取邮件信息
 * @param {*} id 
 */
 export function getEmailInfo(id) {
  return service({
    url: `/fleet/payment_report/email_info/${id}`,
    method: "get",
    headers: {
      "portal-token": true
    },
  })
}

/**
 * 删除Report
 * @param {*} data 
 */
 export function deleteReportRow(data, reset) {
  return service({
    url: `/fleet/payment_report/delete/${reset}`,
    method: "post",
    headers: {
      "portal-token": true
    },
    data
  })
}

/**
 * 获取 unfinalized 列表
 * @param {*} id 
 * @returns 
 */
export function getUnfinalizedList(id) {
  return service({
    url: `/fleet/payment_report/un_finalized/list/${id}`,
    method: "get",
    headers: {
      "portal-token": true
    },
  })
}

/**
 * finalized
 * @param {*} id 
 * @returns 
 */
export function finalizedItem(id) {
  return service({
    url: `/fleet/payment_report/finalized/${id}`,
    method: "get",
    headers: {
      "portal-token": true
    }
  })
}

/**
 * revert
 * @param {*} id 
 * @returns 
 */
export function revertItem(id) {
  return service({
    url: `/fleet/payment_report/un_finalized/revert/${id}`,
    method: "get",
    headers: {
      "portal-token": true,
    },
  })
}

/**
 * 获取 payType 列表
 * @param {*} id 
 * @returns 
 */
export function getPayType(id) {
  return service({
    url: `/fleet/settlement_terms/params/${id}`,
    method: "get",
    headers: {
      "portal-token": true,
    },
  })
}

/**
 * 添加 payment terms
 * @param { settlementScheduleTerms, settlementTermsList } data
 * @returns 
 */
export function addPaymentTerms(data) {
  return service({
    url: "/fleet/settlement_terms/batch/add",
    method: "post",
    headers: {
      "portal-token": true,
    },
    data,
  })
}
